import axios from "axios";

export default {
  actions: {
    checkPassword(ctx, payload) {
      const { uuid, password } = payload;
      return axios
        .post(`/presentation/${uuid}/check_pass`, { password })
        .then(r => {
          if (r) {
            return r;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    getPresentation(ctx, id) {
      return axios
        .get(`/presentation/${id}`)
        .then(r => {
          if (r.status === 200) {
            return r.data;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.error;
        });
    },
    postPresentationComment(ctx, payload) {
      const { id, body, params } = payload;
      return axios
        .post(`/comments/offer/${id}`, body)
        .then(r => {
          if (r.status === 201) {
            return r.data;
          }
          return false;
        })
        .catch(error => {
          return error.response.data.message;
        });
    },
    async postPresentationStats({ commit }, { id, body }) {
      try {
        const response = await axios.post(`/presentation/${id}/stats`, body);
        if (response.status === 200) {
          return response;
        }
      } catch (e) {
        // commit("setError", e);
      }
    }
  }
};
